import * as React from "react"
import { Typeahead, AsyncTypeahead } from "react-bootstrap-typeahead"
import { Button, Form } from "react-bootstrap"
import { FaAngleDown } from "react-icons/fa"
import AutoFilterCompany from "../../api/Companies/CompanyModel/AutoFilterCompany"
import { concat, of, Subject, Subscription } from "rxjs"
import { catchError, debounceTime, filter, map, switchMap } from "rxjs/operators"
import { DataLoader } from "../OrderRequests/GovCollection"
import { RouteComponentProps, withRouter } from "react-router"
import { AutoFilterLocationsGet } from "../../api/Location/AutoFilterLocationsGet"
import { WorkforceClinicPortal } from "../../AppState"

interface LocationInputState {
  locations: DataLoader<AutoFilterCompany>
}

interface LocationInputProps {
  defaultValue?: string
  companyID: number
  id?: string
  disabled?: boolean
  filter?: boolean
  placeholder?: string
  emptyLabel?: string
  hideInactive?: boolean
  onChange?: (items: AutoFilterCompany[]) => void
}

class LocationInput extends React.PureComponent<LocationInputProps & RouteComponentProps, LocationInputState> {
  locationAsyncTypeahead = React.createRef<AsyncTypeahead<AutoFilterCompany>>()
  locationTypeahead = React.createRef<Typeahead<AutoFilterCompany>>()
  locations$ = new Subject<string>()
  subscription?: Subscription
  state: LocationInputState = { locations: {} }
  defaultLocationName: string = this.props.defaultValue || this.getLocationName()

  componentDidMount() {
    this.subscribeLocations()
    this.onInputChange(this.defaultLocationName)
  }

  componentDidUpdate(prevProps: LocationInputProps & RouteComponentProps, prevState: LocationInputState) {
    if (!this.defaultLocationName && this.props.location.pathname !== prevProps.location.pathname) {
      this.locationAsyncTypeahead?.current?.clear()
      this.onInputChange("")
    }
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
  }

  onInputChange(value: string) {
    if (value === "") {
      this.setState({ locations: { selected: undefined } }, () => this.props.onChange && this.props.onChange([]))
    }
    else {
      this.locations$.next(value)
    }
  }

  getLocationName() {
    const participation = sessionStorage.getItem("company-selection")
    const portals: WorkforceClinicPortal[] = JSON.parse(sessionStorage.getItem("wf2-STRY0045127-portals") || "{}")
    var company = undefined
    for (const p of portals) {
      for (const c of p.AssignedClientDetailsOfClinic) {
        if (c.ParticipationID.toString() == participation) {
          company = c
          break
        }
      }
      if (company) {
        break
      }
    }
    return company?.LocationName || ""
  }

  onChange = (locations: AutoFilterCompany[]) => {
    const selectedLocation = locations[0]
    this.setState({ locations: {...this.state.locations, selected: selectedLocation} })
    this.props.onChange && this.props.onChange(locations)
  }

  subscribeLocations() {
    this.subscription = this.locations$.pipe(
      debounceTime(500),
      filter(filter => filter.length >= 1 || filter.length === 0),
      switchMap((filter) => filter.length === 0 ?
        of({ loading: false, locations: this.state.locations.data }) :
        concat(
          of({ loading: true }),
          AutoFilterLocationsGet(this.props.companyID, filter, !!this.props.hideInactive).pipe(
            map((data) => ({ loading: false, locations: data })),
            catchError(() => of({ loading: false }))
          )
        )
      )
    ).subscribe(
      (state: { loading: boolean, locations?: AutoFilterCompany[] }) => {
        state.locations ?
          this.setState({ locations: { loading: state.loading, data: state.locations, selected: this.defaultLocationName ? state.locations[0] : undefined} }, () => this.defaultLocationName && this.onChange((state.locations || []))) :
          this.setState({ locations: { loading: state.loading } })
      },
      () => this.setState({ locations: { loading: false } })
    )
  }

  render() {
    return (
      <>
        { !this.defaultLocationName ? <AsyncTypeahead
          useCache={false}
          disabled={this.props.disabled}
          emptyLabel={this.props.emptyLabel || "No Locations Found"}
          filterBy={(option, props) => this.props.filter ? props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 : true}
          id={this.props.id || "location"}
          isLoading={!!this.state.locations.loading}
          labelKey="Name"
          minLength={0}
          onInputChange={input => this.onInputChange(input)}
          onChange={items => this.onChange(items)}
          onSearch={() => { }}
          options={this.state.locations.data || []}
          placeholder={this.props.placeholder || "Enter the Location name"}
          ref={this.locationAsyncTypeahead}
          selected={this.state.locations.selected ? [this.state.locations.selected] : []}>
          {!this.state.locations.loading && !this.props.disabled &&
            <Button variant="toggle" onClick={() => { this.locationAsyncTypeahead?.current?.toggleMenu() }}>
              <FaAngleDown />
            </Button>}
        </AsyncTypeahead> : <Form.Control type="text" disabled defaultValue={this.state.locations.selected?.Name || ""} />}
      </>
    )
  }
}

export default withRouter(LocationInput)
